import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import { H2, P, Btn } from '../AbstractElements';
import AuthShell from './AuthShell';
import { completeLogin } from './completeLogin';
import API_BASE_URL from '../Config/api';

// Public landing page for the emailed magic-link URL (/auth/magic-link?token=...).
// Consuming the single-use token is an explicit POST triggered here, not a
// side effect of the GET navigation itself, so link-scanners/prefetchers that
// follow the URL from the inbox can't silently burn it.
const MagicLinkVerify = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('verifying'); // 'verifying' | 'error'
    const navigate = useNavigate();
    const attempted = useRef(false);

    useEffect(() => {
        const token = searchParams.get('token');
        if (!token) {
            setStatus('error');
            return;
        }
        if (attempted.current) return;
        attempted.current = true;

        axios.post(`${API_BASE_URL}/api/auth/passwordless/magic/verify`, { token })
            .then((response) => {
                toast.success('Login Success!');
                completeLogin(navigate, response.data);
            })
            .catch((error) => {
                toast.error(error.response?.data?.error || 'This link is invalid or has expired.');
                setStatus('error');
            });
    }, [searchParams, navigate]);

    return (
        <AuthShell>
            <Fragment>
                <H2 attrH2={{ className: 'text-center' }}>Signing you in&hellip;</H2>
                {status === 'verifying' && (
                    <P attrPara={{ className: 'text-center' }}>Please wait while we verify your login link.</P>
                )}
                {status === 'error' && (
                    <Fragment>
                        <P attrPara={{ className: 'text-center' }}>This link is invalid or has expired. Links can only be used once and expire after 10 minutes.</P>
                        <div className='text-center mt-3'>
                            <Link to='/login'><Btn attrBtn={{ color: 'primary' }}>Back to login</Btn></Link>
                        </div>
                    </Fragment>
                )}
            </Fragment>
        </AuthShell>
    );
};

export default MagicLinkVerify;
